import { DropdownItem, SplitButtonDropdown } from '@carboncopyco/ui';
import { getMaxZIndex } from '@carboncopyco/utils';

interface CreateButtonProps {
  disabled?: boolean;
  onClick: (shouldRefresh?: boolean) => void;
}

export const CreateButton = ({ onClick, disabled }: CreateButtonProps) => {
  return (
    <SplitButtonDropdown
      dropdownProps={{
        zIndex: getMaxZIndex() + 1,
      }}
      label="Create"
      primaryTooltipTitle="Create"
      dropdownTriggerTooltipTitle="Review options"
      onClick={() => onClick(true)}
      disabled={disabled}
    >
      <DropdownItem
        label="Create another rule"
        onClick={() => onClick(false)}
      />
    </SplitButtonDropdown>
  );
};
